module.exports = {
    check_email:'Please enter the correct email format',
    check_phone:'Please enter the correct phone number format',
    check_password:'At least 8 characters, including 1 number, at least 1 uppercase character',
    not_character:'Special characters are not supported',
    decimal_two:'You can only enter at most two decimal places',
    be_about_to_pop:'Coming soon, stay tuned!',
    withdrawal_address_incorrect: "The withdrawal address is incorrect",
    Minimum_cash_out_amount: 'Minimum cash out amount is 50 USDT'
}
